module.exports = __webpack_public_path__ + "static/media/investments-grants.9b68caca.svg";